var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('modal',{ref:"ActivarTienda",attrs:{"titulo":"Activar Leechero","icon":"check"},on:{"guardar":_vm.cambiar_estado}},[_c('div',{staticClass:"row mx-0 justify-center mb-3"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"text-muted2 text-center f-15"},[_vm._v(" ¿Desea poner el producción la tienda? ")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }